"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DollHousePackageQuality = void 0;
var DollHousePackageQuality;
(function (DollHousePackageQuality) {
    DollHousePackageQuality["Low"] = "Low";
    DollHousePackageQuality["Medium"] = "Medium";
    DollHousePackageQuality["High"] = "High";
    DollHousePackageQuality["Ultra"] = "Ultra";
})(DollHousePackageQuality = exports.DollHousePackageQuality || (exports.DollHousePackageQuality = {}));
//# sourceMappingURL=DollHouse.enums.js.map